module.exports = __webpack_public_path__ + "static/media/07C.de809be2.png";